<!-- ShoppingCart.vue -->
<template>
  <v-container>
    <v-row justify="center" style="background-color: white">
      <v-col cols="12" sm="10" md="8" lg="8">
        <v-card flat class="mx-auto">
          <!-- <v-card-title>Centered Card</v-card-title> -->
          <v-card-text>
            <v-container class="cart-tool">
              <v-toolbar class="mx-auto" flat>
                <WebSiteHeader></WebSiteHeader>
                <v-spacer></v-spacer>
                <div>
                  {{ summary }}
                </div>
                <v-btn v-if="!inCart" class="mr-4" text>
                  <v-icon class="ma-2">mdi-cart</v-icon> {{ myCart }}
                </v-btn>
                <v-btn
                  @click="clearCart"
                  v-if="!inCart && cart.length"
                  text
                  class="ma-2"
                  color="warning"
                  >Clear Cart</v-btn
                >
                <v-btn
                  @click="goToCart"
                  class="ma-2"
                  v-if="cart.length"
                  :text="inCart"
                  :color="inCart ? 'info' : 'success'"
                  ><v-icon v-if="!inCart" class="ma-2">mdi-check</v-icon>
                  {{ inCart ? "Continue Shopping" : "Go To Cart" }}
                </v-btn>
              </v-toolbar>

              <!-- <router-link v-if="inCart" :to="checkoutUrl"
        >Your 15 days Free Trial ($0 due today)</router-link
      > -->
            </v-container>
            <v-row
              ><v-col>
                <v-btn
                  class="ma-4 justify-center align-center"
                  @click="checkout(true)"
                  color="info"
                  >Start Your 15 days Free Trial</v-btn
                >
              </v-col>

              <v-col>
                <v-btn
                  v-if="inCart"
                  class="ma-4 justify-center align-center"
                  @click="checkout()"
                  color="success"
                  >Buy Now</v-btn
                >
              </v-col>
            </v-row>

            <v-row v-if="!inCart" class="ma-2">
              <v-col
                cols="12"
                md="12"
                lg="6"
                class="moving-package"
                v-for="item in items"
                :key="item._id"
              >
                <v-card :elevation="$vuetify.breakpoint.lgAndUp ? 8 : 0">
                  <v-card-title class="mb-2 mt-4 text-h5 grey lighten-2"
                    ><v-icon class="ma-2">{{ item.icon }}</v-icon
                    >{{ capitalize(item.package_name) }}</v-card-title
                  >
                  <v-card-text>
                    <v-row>
                      <v-col>
                        <v-list v-if="item.users" dense>
                          <v-list-item
                            class="mb-n4 feature"
                            dense
                            v-for="(f, i) in defaultFeatures"
                            :key="i"
                          >
                            <v-icon>mdi-check</v-icon>
                            <div class="feature">{{ f }}</div>
                          </v-list-item>
                        </v-list>
                        <div class="ml-6 mt-2 text--blue" v-if="item.users">
                          <div class="feature">
                            Office Users: <b>{{ item.users }}</b
                            ><br />
                            Field Users:
                            <b class="feature">{{ item.field_users }}</b
                            ><br />
                          </div>
                        </div>
                        <v-container class="features">
                          <v-list
                            v-if="item.features && item.features.length"
                            dense
                          >
                            <h3>PLUS:</h3>
                            <v-list-item
                              class="mb-n4 feature"
                              dense
                              v-for="(f, i) in item.features"
                              :key="i"
                            >
                              <v-icon color="red">mdi-check</v-icon> {{ f }}
                            </v-list-item>
                          </v-list>
                        </v-container>
                      </v-col>
                      <v-col>
                        <h3>Monthly:</h3>
                        <v-container
                          centered
                          rounded
                          class="ml-n2 mt-2 mb-2 pa-4 d-flex justify-center align-center"
                        >
                          <!-- first 15 days
                  <b style="font-size:large">$</b>
                  <h2 class="first-free ma-2">0.00</h2>
                  <br /> -->
                          <b style="font-size: large">$</b>
                          <h1 class="mt-8 price-tag mr-2">
                            {{ item.annually }}
                          </h1>
                          <br />
                          (paid annually)<br />
                        </v-container>
                        <v-container
                          centered
                          rounded
                          class="ml-n2 mt-2 mb-2 pa-4 d-flex justify-center align-center"
                        >
                          <h2 class="mr-2">${{ item.monthly }}</h2>
                          (paid monthly)<br />
                        </v-container>

                        <!-- <v-card class="ml-n2 mt-2 me-2 mb-4" elevation="12">
               <img
                    class="ml-n2 mt-2 pa-2"
                    style="width:100%; "
                    :src="'img/packages/' + 'basic' + '.png'"
                  />
                  <v-carousel></v-carousel>
                </v-card> -->
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-actions>
                    <v-toolbar flat>
                      <v-text-field
                        label="qty"
                        type="number"
                        style="width: 50px"
                        v-model="item.qty"
                      ></v-text-field>
                      <v-spacer></v-spacer>
                      <!-- <div class="text light-green-3">Free 15 days trial</div> -->
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="addToCart(item)"
                      >
                        <v-icon class="ma-2">mdi-cart</v-icon>
                        Add to Cart
                      </v-btn>
                    </v-toolbar>
                  </v-card-actions>
                </v-card>
                <hr />
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col
                cols="12"
                md="6"
                lg="6"
                v-for="item in cart"
                :key="item._id"
              >
                <v-card class="mt-6" elevation="8">
                  <v-card-title class="mb-2 mt-4 text-h5 grey lighten-2"
                    ><v-icon class="ma-2">{{ item.icon }}</v-icon
                    >{{ capitalize(item.package_name) }}</v-card-title
                  >
                  <v-card-text>
                    <v-row>
                      <!-- <v-col>
                <v-list dense>
                  <v-list-item
                    class="mb-n4 feature"
                    dense
                    v-for="(f, i) in defaultFeatures"
                    :key="i"
                  >
                    <v-icon>mdi-check</v-icon>
                    <div class="feature">{{ f }}</div>
                  </v-list-item>
                </v-list>
                <div class="ml-6 mt-2 text--blue" v-if="item.users">
                  <div class="feature">
                    Office Users: <b>{{ item.users }}</b
                    ><br />
                    Field Users: <b class="feature">{{ item.field_users }}</b
                    ><br />
                  </div>
                </div>
                <v-container class="features">
                  <v-list v-if="item.features && item.features.length" dense>
                    <h3>PLUS:</h3>
                    <v-list-item
                      class="mb-n4 feature"
                      dense
                      v-for="(f, i) in item.features"
                      :key="i"
                    >
                      <v-icon color="red">mdi-check</v-icon> {{ f }}
                    </v-list-item>
                  </v-list>
                </v-container>
              </v-col> -->
                      <v-col>
                        <h3>Monthly:</h3>
                        <v-container centered rounded>
                          <!-- first 15 days
                  <b style="font-size:large">$</b>
                  <h2 class="first-free ma-2">0.00</h2>
                  <br /> -->
                          <b style="font-size: large">$</b>
                          <h1 class="mt-8 price-tag mr-2">
                            {{ item.annually }}
                          </h1>
                          <br />
                          (paid annually)<br />
                        </v-container>
                        <v-container
                          centered
                          rounded
                          class="ml-n2 mt-2 mb-2 pa-4 d-flex justify-center align-center"
                        >
                          <h2 class="mr-2">${{ item.monthly }}</h2>
                          (paid monthly)<br />
                        </v-container>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-actions>
                    <v-toolbar flat>
                      <v-text-field
                        label="qty"
                        type="number"
                        style="width: 50px"
                        v-model="item.qty"
                      ></v-text-field>
                      <v-spacer></v-spacer>
                      <!-- <h3 class="text-h7 light-green-3">Free 15 days trial</h3> -->
                      <v-btn color="error" text @click="removeFromCart(item)">
                        <v-icon class="ma-2">mdi-delete</v-icon>
                        Remove From Cart
                      </v-btn>
                    </v-toolbar>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

  <!-- <v-card class="top-container ">
    <v-card-text class="d-flex justify-center  align-center ">
 
    </v-card-text>
  </v-card> -->
</template>

<script>
import axios from "axios";
import * as fun from "../plugins/common";
import vuetify from "../plugins/vuetify";

export default {
  components: {
    Carousel: () => import("../components/UI/Carousel.vue"),
    WebSiteHeader: () => import("../components/UI/WebSiteHeader.vue"),
  },
  props: {
    cart: [],
  },
  data() {
    return {
      items: [],
      defaultFeatures: [
        "Estimate",
        "Visual Inventory",
        "Texting",
        "Scheduling",
        "Dispatch",
        "Payroll",
        "Billing",
        "Paperless",
        "Letter Designer",
        "Report Wizard",
        "Customer Portal",
        "Field Manager",
        "Onsite Estimator",
      ],

      myCart: "Cart is empty",
      inCart: false,
      summary: "",
    };
  },
  created() {
    console.log("created");
  },
  mounted() {
    this.fetchItems();
    if (localStorage.getItem("cart")) {
      this.cart = JSON.parse(localStorage.getItem("cart"));
      this.calculateCart();
    }
  },
  computed: {
    // checkoutUrl() {
    //   var par = "";
    //   this.cart.forEach((c) => {
    //     par += c._id + ":" + c.qty + ";";
    //   });
    //   var url = "/create-account/" + par;
    //   this.$root.$router.push(url);
    //   return url;
    // },
  },
  methods: {
    goToCart() {
      this.inCart = !this.inCart;
      window.scrollTo(0, 0);
    },
    clearCart() {
      localStorage.setItem("cart", "");
      this.cart = [];
      this.calculateCart();
      this.myCart = "Cart is empty";
    },
    capitalize(text) {
      return fun.capitalize(text);
    },
    fetchItems() {
      var data = {
        object_name: "moverai_package",
        db_name: "admin",
        all_records: true,
        qry: {
          emover: null,
        },
      };
      axios
        .post(this.serverURL + "/get_data", data)
        .then((response) => {
          fun.sortObjects(response.data.model, "order");
          this.items = response.data.model;
          this.items.forEach((i) => {
            i.qty = 1;
          });
        })
        .catch((r) => {
          console.log(r);
        });
    },
    checkout(trial) {
      // var par = "";
      // this.cart.forEach((c) => {
      //   par += c._id + ":" + c.qty + ";";
      // });
      var url = "create-account/";
      // if (trial) {
      //   url += "trial";
      // }
      //  + par;
      this.$root.$router.push(url);
      window.location.reload();
      // window.location.href = window.location.href.replace(
      //   "moverai-packages",
      //   url
      // );
    },
    calculateCart() {
      this.summary = "";
      var qty = 0;
      var total = 0;
      this.summary = "";

      var myItems = [];
      this.cart.forEach((c) => {
        qty += parseInt(c.qty);
        var description = fun.capitalize(c.package_name);
        var p = c.users ? " package " : " ";
        myItems.push(c.qty + " " + description + p);
        this.summary = myItems.join(" + ");
      });
      this.myCart = qty + " items";
    },
    addToCart(item) {
      this.cart.push(item);
      localStorage.setItem("cart", JSON.stringify(this.cart));
      this.calculateCart();

      // Implement adding to cart functionality here
      // This could involve storing the item in a Vuex store or local storage
    },
    removeFromCart(item) {
      var ind = this.cart.indexOf(item);

      this.cart.splice(ind, 1);
      localStorage.setItem("cart", JSON.stringify(this.cart));
      this.calculateCart();
    },
  },
};
</script>

<style>
.top-container {
  /* max-width: 70%; */
}
.cart-tool {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  background-color: white;
}
.price-tag {
  font-size: 70px;
  color: #628be4;
}
.first-free {
  font-size: 50px;
  color: #084d13;
}

.feature {
  color: #720b13;
  font-weight: 500;
  white-space: nowrap;
}

.features {
  min-height: 150px;
}

.v-list-item.feature {
  color: red !important;
}

.shadow-elevation {
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 15px 0 rgba(0, 0, 0, 0.16);
}
/* @media only screen and (max-width: 450px) {
  .moving-package {
    min-width: 450px;
    margin-left: -50px;
  }
} */
/*@media only screen and (max-width: 1024px) {
  .moving-package {
    min-width: 550px;
    margin-left: -50px;
  }
} */
</style>
<!-- <style scoped>
@import url("https://moverai.com/wp-content/themes/blocksy/static/bundle/main.min.css?ver=1.9.10");
</style>
<style scoped>
@import url("https://moverai.com/wp-content/themes/blocksy/static/bundle/main.min.css?ver=1.9.10");
</style> -->
